import feature from './component/tutorialModal.vue'
import register from './store'

export default feature;

export {
    register
}
